var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{directives:[{name:"ripple",rawName:"v-ripple"}],class:_vm.ButtonClass,on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("default"),(_vm.loading == true && _vm.disable == true)?_c('div',{staticClass:"loader"},[_vm._v("Loading...")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }